<script lang="ts" setup>
import UserAvatar from "@/components/UserAvatar.vue";
import { inApp } from "@/modules/common";
import ArrowIcon from "@/components/icon/ArrowIcon.vue";
import { computed, ref, watch } from "vue";
import { storeToRefs } from "pinia";
import { useMate } from "@/stores/mate";
import { useRoute, useRouter } from "vue-router";
import LightArrowIcon from "@/components/icon/LightArrowIcon.vue";
import { useGlobalUser } from "@/stores/globalUser";
import i18n from "@/locales";
import { routerBack, HOME_ROUTER } from "@/use/go";
import { useUI } from "@/stores/ui";
const props = withDefaults(
  defineProps<{
    showBack?: boolean;
    showCenter?: boolean;
    showRight?: boolean;
    enableSwitchMate?: boolean;
    backDoubleCheck?: boolean;
    backDoubleCheckMessage?: string;
    showSideNav?: number;
    showLeftLogo?: boolean;
    goBack?: () => void;
    centerClass?: string;
  }>(),
  {
    showBack: false,
    showCenter: true,
    enableSwitchMate: true,
    showRight: true,
    backDoubleCheck: false,
    showSideNav: 0,
    backDoubleCheckMessage: i18n.global.t("Message.sureExit"),
    showLeftLogo: true,
    centerClass: "",
  }
);

const emit = defineEmits<{
  (e: "onDoubleClick"): void;
}>();

watch(
  () => props.showSideNav,
  () => {
    uiStore.showSideDrawer = true;
  }
);
const showBackToHome = computed(() => {
  return (
    !route.meta.showBottomNav &&
    route.meta.landingPage &&
    !route.meta.auth &&
    !route.meta.internal
  );
});

const router = useRouter();
const route = useRoute();
const user = useGlobalUser();
const uiStore = useUI();
const mateStore = useMate();
const { currentMate } = storeToRefs(mateStore);

// EventHandler
const triggerMateSwitch = () => {
  if (props.enableSwitchMate) {
    uiStore.popMateSelector({
      selectionMode: "edit",
    });
  }
};
const goBack = async () => {
  if (props.goBack) {
    props.goBack();
    return;
  }
  await routerBack({
    backDoubleCheck: props.backDoubleCheck,
    backDoubleCheckMessage: props.backDoubleCheckMessage,
  });
};

const showWechat = ref(false);

const showWechatDialog = () => {
  showWechat.value = true;
};

export interface ThreadsNavInstance {
  showWechatDialog: typeof showWechatDialog;
}

defineExpose<ThreadsNavInstance>({
  showWechatDialog,
});
</script>
<template>
  <div
    class="navbar bg-base-100 overflow-hidden gap-2 min-h-0 pb-0"
    @dblclick="emit('onDoubleClick')"
  >
    <!-- 左 -->
    <div
      class="navbar-start h-full flex gap-2 items-center"
      :class="{ 'w-auto': !showRight }"
    >
      <div v-if="!showBack && showLeftLogo" class="flex gap-2 items-center">
        <button
          class="btn btn-ghost btn-square rounded block w-16 px-2"
          @click.stop="router.push({ name: 'threads' })"
        >
          <logo class="w-full h-full text-primary" />
        </button>
        <ApkDownloadBtn v-if="!inApp" class="w-20" />
      </div>
      <template v-if="showBack">
        <button
          v-if="!showBackToHome"
          class="btn btn-ghost btn-square"
          @click.stop="goBack"
        >
          <light-arrow-icon class="text-base" />
        </button>
        <button
          v-else
          class="btn btn-ghost"
          @click.stop="router.push(HOME_ROUTER)"
        >
          <i class="iconfont icon-home" />
        </button>
      </template>
      <slot name="left">
        <!-- <i
          v-else-if="!showBack && currentMate"
          class="iconfont icon-menus-o text-2xl font-bold p-1 cursor-pointer block"
          @click="uiStore.showSideDrawer = true"
        /> -->
      </slot>
    </div>
    <!-- 中 -->
    <div
      class="navbar-center"
      :class="{ 'flex-1': !showCenter, [centerClass]: true }"
    >
      <template v-if="user.isLogin">
        <slot name="center">
          <div v-if="!showCenter"></div>
          <div
            v-else-if="currentMate"
            class="flex gap-1 items-center cursor-pointer"
            @click="triggerMateSwitch"
          >
            <user-avatar
              :mate="currentMate"
              class="w-5 shrink-0 drawer-button mr-1"
            />
            <div class="text-base font-bold">
              {{ currentMate?.name }}
            </div>
            <arrow-icon v-show="enableSwitchMate" class="w-3 mt-1" />
          </div>
        </slot>
      </template>
    </div>
    <!-- 右 -->
    <div v-if="showRight" class="navbar-end flex gap-2 overflow-hidden">
      <slot name="right">
        <template v-if="!user.isLogin">
          <!--        <button-->
          <!--          class="btn btn-ghost btn-circle btn-sm"-->
          <!--          @click="goDiscordLink"-->
          <!--        >-->
          <!--          <i class="iconfont icon-discord1"></i>-->
          <!--        </button>-->
          <button
            class="btn btn-sm rounded"
            @click="
              router.push({
                name: 'mateCreate',
              })
            "
          >
            {{ $t("User.register") }}
          </button>
          <button
            class="btn btn-primary btn-sm rounded"
            @click="
              router.push({
                name: 'login',
                query: { mode: 'login' },
              })
            "
          >
            {{ $t("User.login") }}
          </button>
        </template>
      </slot>
    </div>
  </div>
</template>
